// @ts-nocheck


import React from 'react';


import { brandApi } from '../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';


export default (props) =>
<AutocompleteSelect
  placeholder="Выберите марку"
  fetch={brandApi.fetchBrands}
  fetchSingle={brandApi.fetchBrand}
  notFoundText="Марки не найдены"
  renderOption={(brand, Option) =>
  <Option value={brand.id} key={brand.id}>
        {brand.name}
      </Option>
  }
  {...props} />;
